import React from "react";

interface OtherSourceInputProps {
  otherSourceText: string;
  onOtherSourceTextChange: (value: string) => void;
}

export const OtherSourceInput: React.FC<OtherSourceInputProps> = ({
  otherSourceText,
  onOtherSourceTextChange,
}) => {
  return (
    <div className="mt-2 p-3 bg-orange-50 border border-orange-200 rounded-lg">
      <div className="text-orange-700 text-sm font-medium mb-2">
        💡 구체적인 출처를 알려주세요
      </div>
      <input
        value={otherSourceText}
        onChange={(e) => onOtherSourceTextChange(e.target.value)}
        placeholder="예: 페이스북, 카카오톡, 지인 소개 등"
        className="w-full px-3 py-2 border border-orange-300 rounded-lg focus:outline-none focus:border-orange-500 focus:ring-2 focus:ring-orange-200 transition text-gray-700 bg-white text-sm"
      />
    </div>
  );
};
